import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";
import { Step } from "../../Limestone/AxProgressBar/AxProgressBar";

export class ProgressBar {
    constructor(private i18nHelper = new I18nHelper()) { }
    GetGiftCardSteps(): Step[] {
        return [
            {
                label: this.i18nHelper.GetTranslation(Translations.AmountAndDesign),
                type: 'inactive'
            },
            {
                label: this.i18nHelper.GetTranslation(Translations.Personalize),
                type: 'inactive'
            },
        ];
    }
}